import { useEffect, useState } from 'react';
import { defineConfig } from 'sanity';
import { structureTool } from 'sanity/structure';
import { visionTool } from '@sanity/vision';
import { Studio } from 'sanity';

// Import your schema types
import schemas from '../sanity/schemas';

// Import your logo component or image
// You can create a simple React component for your logo
const YAAPLogo = () => {
	return (
		<div style={{ display: 'flex', alignItems: 'center' }}>
			<img
				src='/yaap.svg'
				alt='YAAP Logo'
				style={{ height: '2rem', width: '2rem' }}
			/>
			<span style={{ marginLeft: '8px', fontWeight: 'bold', color: 'white' }}>
				YAAP
			</span>
		</div>
	);
};

const config = defineConfig({
	name: 'default',
	title: 'Yaap Content Studio',
	projectId: import.meta.env.VITE_SANITY_PROJECT_ID || 'your-project-id',
	dataset: import.meta.env.VITE_SANITY_DATASET || 'production',
	plugins: [structureTool(), visionTool()],
	schema: {
		types: schemas,
	},
	icon: YAAPLogo,
	studio: {
		components: {
			logo: YAAPLogo,
		},
	},
	basePath: '/studio',
});

export default function SanityStudio() {
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
		return () => setMounted(false);
	}, []);
	// Only render the Studio on the client side
	if (!mounted) return null;

	return (
		<div style={{ height: '100vh', width: '100%' }}>
			<Studio config={config} />
		</div>
	);
}
